import { render, staticRenderFns } from "./twoPie.vue?vue&type=template&id=57cffca8&scoped=true"
import script from "./twoPie.vue?vue&type=script&lang=js"
export * from "./twoPie.vue?vue&type=script&lang=js"
import style0 from "./twoPie.vue?vue&type=style&index=0&id=57cffca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cffca8",
  null
  
)

export default component.exports